/** Which of a palette's colours a shape is drawn in. */
export type AvatarTone = "soft" | "pale" | "deep";

/**
 * The colours of one generated avatar. `ground` fills the disc and rings its edge: it is a
 * mid-tone at least 3:1 against every theme's page and surface colours, so the disc's
 * outline stays visible in light and dark themes alike. The tones are lighter and darker
 * shades of the same hue, so each avatar stays calm.
 */
export interface AvatarPalette {
  readonly name: string;
  readonly ground: string;
  readonly soft: string;
  readonly pale: string;
  readonly deep: string;
}

export const AVATAR_PALETTES: readonly AvatarPalette[] = [
  { name: "teal", ground: "#428078", soft: "#8bcbc2", pale: "#ceebe7", deep: "#1d3936" },
  { name: "blue", ground: "#5178a4", soft: "#abc1db", pale: "#dce6f1", deep: "#243649" },
  { name: "indigo", ground: "#6a72a7", soft: "#b8bddb", pale: "#e2e4f1", deep: "#2e334f" },
  { name: "plum", ground: "#976597", soft: "#d4b5d4", pale: "#eee0ee", deep: "#432d43" },
  { name: "rose", ground: "#a9606a", soft: "#ddb6bb", pale: "#f2e1e3", deep: "#4e2a2f" },
  { name: "clay", ground: "#a1684f", soft: "#dab8a9", pale: "#f1e1da", deep: "#482e23" },
  { name: "ochre", ground: "#8d723c", soft: "#d4bc8c", pale: "#efe4cf", deep: "#3e331b" },
  { name: "moss", ground: "#687d4a", soft: "#b1c792", pale: "#dde8ce", deep: "#2f3821" },
  { name: "sea", ground: "#4b8166", soft: "#98cab1", pale: "#d2eade", deep: "#223a2e" },
];
